var exports = {
  "kL": "container__ElsVa2",
  "rb": "mainContent__Ty1Hu-",
  "Rm": "toggleButton__DZhVKP",
  "Kk": "icon__igppbS",
  "Qq": "text__95a5hc",
  "fr": "textWithShimmer__ZC1CCq",
  "Su": "titleWithShimmer__WQ9DB3",
};

module.exports = exports;
